export const validGtd = (str) => {
  return /^\d{8}\/\d{6}\/\d{7}\/?\d*$/.test(str);
};
